import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

const SkeletonLoader = (props) => {
  return (
    <>
      {props.type === "text" && (
        <Skeleton
          variant="rect"
          width={props.width ? props.width : "100%"}
          height={props.height ? props.height : "100%"}
          {...props}
        />
      )}
    </>
  );
};

export default SkeletonLoader;
